// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var RandomId$ReactHooksTemplate = require("./RandomId.res.js");
var RatingSmileySet$ReactHooksTemplate = require("./ratingSmileySet.res.js");

function decodeLabel(json) {
  return {
          rating: Json_decode.field("id", Json_decode.$$int, json),
          label: Json_decode.field("label", Json_decode.string, json)
        };
}

function decode(json) {
  return {
          text: Json_decode.withDefault("", (function (param) {
                  return Json_decode.field("text", Json_decode.string, param);
                }), json),
          description: Json_decode.withDefault("", (function (param) {
                  return Json_decode.field("description", Json_decode.string, param);
                }), json),
          ratingLabels: Json_decode.withDefault(/* [] */0, (function (param) {
                  return Json_decode.field("options", (function (param) {
                                return Json_decode.list(decodeLabel, param);
                              }), param);
                }), json)
        };
}

function answer(t) {
  return t.answer;
}

function answered(t) {
  return t.answer !== undefined;
}

function empty(param) {
  return {
          id: undefined,
          uuid: RandomId$ReactHooksTemplate.generate(),
          text: "",
          description: "",
          ratingSmileySet: undefined,
          showLabels: true,
          negativeToPositive: true,
          translations: /* [] */0,
          answer: undefined
        };
}

function id(t) {
  return t.id;
}

function uuid(t) {
  return t.uuid;
}

function duplicate(q) {
  return {
          id: undefined,
          uuid: RandomId$ReactHooksTemplate.generate(),
          text: q.text,
          description: q.description,
          ratingSmileySet: q.ratingSmileySet,
          showLabels: q.showLabels,
          negativeToPositive: q.negativeToPositive,
          translations: q.translations,
          answer: q.answer
        };
}

function text(t) {
  return t.text;
}

function getTextTranslation(t, language) {
  var translation = List.find_opt((function (param) {
          return param[0] === language;
        }), t.translations);
  if (translation !== undefined) {
    return translation[1].text;
  } else {
    return t.text;
  }
}

function description(t) {
  return t.description;
}

function getDescriptionTranslation(t, language) {
  var translation = List.find_opt((function (param) {
          return param[0] === language;
        }), t.translations);
  if (translation !== undefined) {
    return translation[1].description;
  } else {
    return t.description;
  }
}

function showLabels(t) {
  return t.showLabels;
}

function negativeToPositive(t) {
  return t.negativeToPositive;
}

function ratingSmileySet(t) {
  return t.ratingSmileySet;
}

function ratingTypeCollection(t) {
  if (t.negativeToPositive) {
    return {
            hd: "One",
            tl: {
              hd: "Two",
              tl: {
                hd: "Three",
                tl: {
                  hd: "Four",
                  tl: {
                    hd: "Five",
                    tl: /* [] */0
                  }
                }
              }
            }
          };
  } else {
    return {
            hd: "Five",
            tl: {
              hd: "Four",
              tl: {
                hd: "Three",
                tl: {
                  hd: "Two",
                  tl: {
                    hd: "One",
                    tl: /* [] */0
                  }
                }
              }
            }
          };
  }
}

function ratingTypeToImage(ratingType, ratingSmileySet) {
  switch (ratingType) {
    case "One" :
        return RatingSmileySet$ReactHooksTemplate.ratingOneSmiley(ratingSmileySet);
    case "Two" :
        return RatingSmileySet$ReactHooksTemplate.ratingTwoSmiley(ratingSmileySet);
    case "Three" :
        return RatingSmileySet$ReactHooksTemplate.ratingThreeSmiley(ratingSmileySet);
    case "Four" :
        return RatingSmileySet$ReactHooksTemplate.ratingFourSmiley(ratingSmileySet);
    case "Five" :
        return RatingSmileySet$ReactHooksTemplate.ratingFiveSmiley(ratingSmileySet);
    case "NotSelected" :
        return Image$ReactHooksTemplate.excellentSmiley;
    
  }
}

function ratingTypeToString(x) {
  switch (x) {
    case "One" :
        return "Poor";
    case "Two" :
        return "Fair";
    case "Three" :
        return "Good";
    case "Four" :
        return "Very Good";
    case "Five" :
        return "Excellent";
    case "NotSelected" :
        return "";
    
  }
}

function ratingTypeToRating(x) {
  switch (x) {
    case "One" :
        return 1;
    case "Two" :
        return 2;
    case "Three" :
        return 3;
    case "Four" :
        return 4;
    case "Five" :
        return 5;
    case "NotSelected" :
        return -1;
    
  }
}

function ratingLabelToString(t, ratingType, language) {
  var ratingValue = ratingTypeToRating(ratingType);
  if (ratingValue === -1) {
    return "";
  }
  var match = List.find_opt((function (param) {
          return param[0] === language;
        }), t.translations);
  if (match === undefined) {
    return ratingTypeToString(ratingType);
  }
  var ratingLabel = List.find_opt((function (ratingLabel) {
          return ratingLabel.rating === ratingValue;
        }), match[1].ratingLabels);
  if (ratingLabel !== undefined) {
    return ratingLabel.label;
  } else {
    return ratingTypeToString(ratingType);
  }
}

function answerToString(t) {
  var answer = t.answer;
  if (answer !== undefined) {
    return ratingTypeToString(answer);
  } else {
    return "";
  }
}

function answerToInt(t) {
  var answer = t.answer;
  if (answer !== undefined) {
    return ratingTypeToRating(answer);
  }
  
}

function answerRange(_t) {
  return [
          1,
          5
        ];
}

function setText(t, text) {
  return {
          id: t.id,
          uuid: t.uuid,
          text: text,
          description: t.description,
          ratingSmileySet: t.ratingSmileySet,
          showLabels: t.showLabels,
          negativeToPositive: t.negativeToPositive,
          translations: t.translations,
          answer: t.answer
        };
}

function setDescription(t, description) {
  return {
          id: t.id,
          uuid: t.uuid,
          text: t.text,
          description: description,
          ratingSmileySet: t.ratingSmileySet,
          showLabels: t.showLabels,
          negativeToPositive: t.negativeToPositive,
          translations: t.translations,
          answer: t.answer
        };
}

function setShowLabels(t, showLabels) {
  return {
          id: t.id,
          uuid: t.uuid,
          text: t.text,
          description: t.description,
          ratingSmileySet: t.ratingSmileySet,
          showLabels: showLabels,
          negativeToPositive: t.negativeToPositive,
          translations: t.translations,
          answer: t.answer
        };
}

function setNegativeToPositive(t, negativeToPositive) {
  return {
          id: t.id,
          uuid: t.uuid,
          text: t.text,
          description: t.description,
          ratingSmileySet: t.ratingSmileySet,
          showLabels: t.showLabels,
          negativeToPositive: negativeToPositive,
          translations: t.translations,
          answer: t.answer
        };
}

function setAnswer(t, answer) {
  return {
          id: t.id,
          uuid: t.uuid,
          text: t.text,
          description: t.description,
          ratingSmileySet: t.ratingSmileySet,
          showLabels: t.showLabels,
          negativeToPositive: t.negativeToPositive,
          translations: t.translations,
          answer: answer
        };
}

function setRatingSmileySet(t, ratingSmileySet) {
  return {
          id: t.id,
          uuid: t.uuid,
          text: t.text,
          description: t.description,
          ratingSmileySet: ratingSmileySet,
          showLabels: t.showLabels,
          negativeToPositive: t.negativeToPositive,
          translations: t.translations,
          answer: t.answer
        };
}

function encodeAnswerTypeCollection(option) {
  return Json_encode.object_({
              hd: [
                "id",
                ratingTypeToRating(option)
              ],
              tl: {
                hd: [
                  "label",
                  ratingTypeToString(option)
                ],
                tl: /* [] */0
              }
            });
}

function toJson(withAnswerOpt, t) {
  var withAnswer = withAnswerOpt !== undefined ? withAnswerOpt : false;
  var x = t.ratingSmileySet;
  var encodeArray_0 = [
    "id",
    Json_encode.nullable((function (prim) {
            return prim;
          }), t.id)
  ];
  var encodeArray_1 = {
    hd: [
      "text",
      t.text
    ],
    tl: {
      hd: [
        "description",
        t.description
      ],
      tl: {
        hd: [
          "options",
          Json_encode.list(encodeAnswerTypeCollection, ratingTypeCollection(t))
        ],
        tl: {
          hd: [
            "rating_smiley_set_id",
            x !== undefined ? RatingSmileySet$ReactHooksTemplate.id(x) : 0
          ],
          tl: /* [] */0
        }
      }
    }
  };
  var encodeArray = {
    hd: encodeArray_0,
    tl: encodeArray_1
  };
  return Json_encode.object_(withAnswer ? ({
                  hd: [
                    "answer",
                    ratingTypeToRating(Belt_Option.getWithDefault(t.answer, "NotSelected"))
                  ],
                  tl: encodeArray
                }) : encodeArray);
}

function decodeTranslation(json) {
  return [
          Json_decode.field("survey_language", (function (param) {
                  return Json_decode.field("name", Json_decode.string, param);
                }), json),
          Json_decode.field("key_string_mapping", decode, json)
        ];
}

function fromJson(json) {
  return {
          id: Json_decode.field("category", (function (param) {
                  return Json_decode.field("id", (function (param) {
                                return Json_decode.optional(Json_decode.$$int, param);
                              }), param);
                }), json),
          uuid: Json_decode.field("uid", RandomId$ReactHooksTemplate.fromJson, json),
          text: Json_decode.field("category", (function (param) {
                  return Json_decode.field("text", Json_decode.string, param);
                }), json),
          description: Json_decode.field("category", (function (param) {
                  return Json_decode.field("description", Json_decode.string, param);
                }), json),
          ratingSmileySet: Json_decode.optional((function (param) {
                  return Json_decode.field("category", (function (param) {
                                return Json_decode.field("rating_smiley_set", RatingSmileySet$ReactHooksTemplate.fromJson, param);
                              }), param);
                }), json),
          showLabels: Json_decode.field("category", (function (param) {
                  return Json_decode.field("show_labels", Json_decode.bool, param);
                }), json),
          negativeToPositive: Json_decode.field("category", (function (param) {
                  return Json_decode.field("negative_to_positive", Json_decode.bool, param);
                }), json),
          translations: Json_decode.field("translations", (function (param) {
                  return Json_decode.list(decodeTranslation, param);
                }), json),
          answer: undefined
        };
}

var categoryType = "SmileyRating";

exports.text = text;
exports.getTextTranslation = getTextTranslation;
exports.description = description;
exports.answer = answer;
exports.getDescriptionTranslation = getDescriptionTranslation;
exports.showLabels = showLabels;
exports.negativeToPositive = negativeToPositive;
exports.ratingSmileySet = ratingSmileySet;
exports.ratingTypeCollection = ratingTypeCollection;
exports.ratingTypeToImage = ratingTypeToImage;
exports.ratingTypeToString = ratingTypeToString;
exports.ratingLabelToString = ratingLabelToString;
exports.ratingTypeToRating = ratingTypeToRating;
exports.setText = setText;
exports.setShowLabels = setShowLabels;
exports.setNegativeToPositive = setNegativeToPositive;
exports.setDescription = setDescription;
exports.setRatingSmileySet = setRatingSmileySet;
exports.categoryType = categoryType;
exports.answered = answered;
exports.empty = empty;
exports.id = id;
exports.uuid = uuid;
exports.toJson = toJson;
exports.setAnswer = setAnswer;
exports.fromJson = fromJson;
exports.answerToString = answerToString;
exports.answerRange = answerRange;
exports.answerToInt = answerToInt;
exports.duplicate = duplicate;
/* Image-ReactHooksTemplate Not a pure module */
